module.exports = __webpack_public_path__ + "img/gachita_main.831df032.png";